// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"18197bb2","488":"4f17c045"}[chunkId] + ".chunk.js";
};